import { AdminPagesStateModel } from "../../admin.state";
import { Pier } from "../models/pier.model";

export class PiersStateModel extends AdminPagesStateModel {
  items: Pier[];
}
